<template>
	<div class="pageContainer app-container studentContainer">
		<el-row>
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">
				<el-option label="学生编号" value="stu_code">学生编号</el-option>
				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="建档号" value="archive">建档号</el-option>
				<el-option label="考试证号" value="exam_num">考试证号</el-option>
				<el-option label="联系方式" value="phone">联系方式</el-option>
				<el-option label="地区" value="graduate_sch_city">地区</el-option>
				<el-option label="专业名称" value="zhuanye">专业名称</el-option>
			</el-select>
			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
				style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />

			<span>报考状态：</span>
			<el-select v-model="searchForm.status" size="small" placeholder="请选择"
				style="width: 150px; margin-right: 10px;">
				<el-option label="全部" value="all"></el-option>
				<el-option label="未审核" :value="0"></el-option>
				<el-option label="审核通过" :value="1"></el-option>
				<el-option label="审核不通过" :value="-1"></el-option>
			</el-select>
			<span>视频报送状态：</span>
			<el-select v-model="searchForm.flag" size="small" placeholder="请选择"
				style="width: 150px; margin-right: 10px;">
				<el-option label="全部" value=""></el-option>
				<el-option label="未审核" :value="0"></el-option>
				<el-option label="已审核" :value="1"></el-option>
				<el-option label="报送不符合要求" :value="-1"></el-option>
				
			</el-select>
			<span v-if="$store.state.pmid==6">专业：</span>
			<el-select v-if="$store.state.pmid==6" v-model="searchForm.major_type" size="small" placeholder="请选择"
				style="width: 150px;">
				
				<el-option label="五年制高职" value="五年制高职"></el-option>
				
				

			</el-select>

			<el-button size="small" icon="el-icon-search" @click="getList()" plain type="primary"
				style="margin-left: 20px;">查询</el-button>




		</el-row>
		<el-row type="flex" :gutter="16" style="margin-top: 20px">

			<el-col :span="24" class="tabContainer">
				<el-tabs v-model="activeName"  type="card" style="">
					<el-tab-pane label="学生列表" name="学生列表">

					</el-tab-pane>

				</el-tabs>
				<div>
					<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
						size="mini">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column type="index" label="序号" width="60"></el-table-column>

						<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
						<!-- <el-table-column prop="archive" label="建档号" width="120"></el-table-column> -->


						<el-table-column prop="gender" label="性别" width="60">
							<template slot-scope="scope">

								<span v-if="scope.row.gender==1">男</span>
								<span v-if="scope.row.gender==2">女</span>

								<span v-if="scope.row.gender==0">未知</span>
							</template>
						</el-table-column>
						<el-table-column prop="exam_num" label="准考证号" width="100">
							<template slot-scope="scope">

								<span @click="showZkz(scope.row)">{{scope.row.exam_num}}</span>

							</template>
						</el-table-column>
						<el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>

						<el-table-column prop="major_name" label="报考专业" min-width="140">
							<template slot-scope="scope">
								<span v-if="!scope.row.isflag2"><strong style="color: orangered;">[主]</strong>{{scope.row.major_name}}[{{scope.row.xuezhi}}]{{scope.row.remark}}</span>
								<span v-if="scope.row.isflag2"><strong style="color:dodgerblue;">[兼]</strong>{{scope.row.major_name2}}[{{scope.row.xuezhi2}}]</span>
							</template>
						</el-table-column>


						<el-table-column prop="phone" label="联系方式" width="120">
							<template slot-scope="scope">
								<span>{{scope.row.phone||scope.row.jhr1phone}}</span>

							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.status==1" style="color: green;">已审核</span>
								<span v-if="scope.row.status==2" style="color: blue;">已缴费</span>
								<span v-if="scope.row.status==3" style="color: deepskyblue;">已录取</span>
								<span v-if="scope.row.status==4" style="color: #096DD9;">已分班</span>
								<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
								<span v-if="scope.row.status==0" style="color: gray;">未审核</span>
							</template>
						</el-table-column>

						
						<el-table-column prop="username" label="视频报送状态" min-width="100">
							<template slot-scope="scope">
								<span v-if="!scope.row.isflag2" >{{scope.row.flag}}</span>
								<span v-else >{{scope.row.flag2}}</span>

							</template>
						</el-table-column>
						<el-table-column prop="cdate" label="审核时间" width="150">
							<template slot-scope="scope">
								<span v-if="!scope.row.isflag2">{{scope.row.flag_time}}</span>
								<span v-if="scope.row.isflag2">{{scope.row.flag2_time}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="cdate" label="审核人" width="80">
							<template slot-scope="scope">
								<span v-if="!scope.row.isflag2">{{scope.row.f1_teacher}}</span>
								<span v-if="scope.row.isflag2">{{scope.row.f2_teacher}}</span>
							</template>
						</el-table-column>


						<el-table-column fixed="right" label="操作" width="140" >
							<template slot-scope="scope">
								<el-button @click="showBaosong(scope.row)" type="text" size="small">视频审核</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex"
						:page-size="page.pageSize" :total="page.total" @size-change="handleSizeChange"
						:page-sizes="page.pageSizes" layout="total, prev, pager, next, sizes, jumper">
					</el-pagination>
				</div>

			</el-col>
		</el-row>

		<el-dialog :title="modalTitle" width="800px" :visible.sync="viewDialog" :close-on-click-modal="false">
			<el-form :inline="true" label-width="80px">
				<el-row>
					<el-form-item label="专业信息">
						{{major}}
					</el-form-item>
					<el-form-item label="审核项">
						<el-select v-model="shipin.flag" style="width: 400px;" placeholder="请选择审核项">
							<el-option label="视频已收到，符合上传要求。" value="视频已收到，符合上传要求。"></el-option>
							<el-option label="视频不符合上传要求。" value="视频不符合上传要求。"></el-option>
							<el-option label="艺术设计作品已收到，符合考试要求。" value="艺术设计作品已收到，符合考试要求。"></el-option>
							<el-option label="艺术设计作品已收到，不符合考试要求。" value="艺术设计作品已收到，不符合考试要求。"></el-option>
							<el-option label="无" value="无"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核结果">
						<el-input clearable v-model.trim="shipin.flag_remark" type="textarea" placeholder="请输入审核结果详细信息"
							:autosize="{ minRows: 2, maxRows: 6 }" style="width: 600px" />
					</el-form-item>
				</el-row>
				<el-row>
					<div style="text-align: right;">
						<el-button size="small" type="infor" icon="el-icon-back" @click="viewDialog=false">取消
						</el-button>
						<el-button size="small" type="primary" icon="el-icon-check" @click="saveForm">保存</el-button>

					</div>
				</el-row>
			</el-form>
		</el-dialog>

	</div>
</template>
<script>
	import TableXjxx from '../components/Table_xjxx'

	export default {
		name: 'Student',
		components: {

			TableXjxx

		},
		data() {
			return {
				searchForm: {
					flag:"",
					ktype: 'stu_name',
					status: 'all',
					major_type: "五年制高职"
				}, //查询
				modalTitle: '视频报送',
				viewDialog: false,
				activeName:"学生列表",
				tableData:[],
				page: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50],
					total: 0
				},
				shipin: {
					id:0,
					flag: "",
					flag_remark: ""
				},
				major:"",
				isflag2:false

			}
		},

		mounted() {
			this.getList();


		},
		methods: {


			//table
			getList() {
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					status: this.searchForm.status,
					ktype: this.searchForm.ktype,
					keyword: this.searchForm.keyword,
					major_type: this.searchForm.major_type,
					flag: this.searchForm.flag
				}
				if (this.searchForm.major_type != "其他渠道") {
					params.stu_from_type = 3 //0专业意向登记
				}

				if (this.$store.state.pmid == 2) { //南京工程只显示教师所在的区域的数据
					this.$http.post("/api/sch_students_list_pre", params).then(res => {

						this.tableData = res.data.data
						this.page.total = res.data.page.count
					})
				} else {
					this.$http.post("/api/sch_students_list_pre", params).then(res => {
						if(this.searchForm.keyword&&this.$store.state.pmid==6){//戏剧学院要2个线上专业考试视频（作品）报送情况，主专业和兼报专业
							let arr=[];
							for(let item of res.data.data){
								if(item.major_id2){
									let item2 = JSON.parse(JSON.stringify(item))
									item2.isflag2=1
									arr.push(item)
									arr.push(item2)
								}else{
									arr.push(item)
								}
								
							}
							this.tableData = arr
						}else{
							this.tableData = res.data.data
						}
						
						this.page.total = res.data.page.count
					})
				}

			},

			handlePageChange(e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleSizeChange(e) {
				this.page.pageSize = e
				this.getList()
			},
			showBaosong(row) {
				this.modalTitle = row.stu_name + "的线上专业考试视频（作品）报送情况"
				if(row.isflag2){
					this.isflag2 = true
					this.major="【兼报】"+row.major_name2+"["+row.xuezhi2+"]"
					this.shipin = {
						id:row.id,
						flag: row.flag2,
						isflag2:this.isflag2,
						flag_remark: row.flag_remark2,
					}
					
				}else{
					this.major="【主报】"+row.major_name+"["+row.xuezhi+"]"
					this.isflag2 = false
					this.shipin = {
						id:row.id,
						isflag2:this.isflag2,
						flag: row.flag,
						flag_remark: row.flag_remark,
					}
				}
				
				this.viewDialog = true
				
				
			},
			saveForm() {
				this.$confirm('确认审核?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$http.post("/api/shipin_baosong", this.shipin).then(res => {
					
						this.$message({
							type: 'success',
							message: '审核成功!'
						});
						this.getList()
						this.viewDialog=false
					})
					
					
					
					
				}).catch(() => {

				});
			}



		}
	}
</script>

<style lang="less" type="text/less">
	.studentContainer{
    .el-tabs__nav{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .el-tabs__item{
        line-height: unset;
        display: flex;
        align-items: center;
    }
    .el-tabs__item.is-disabled {
        color: #303133;
        cursor:default
    }
    .el-tabs__item.is-active {
        color: #409EFF;
    }
}

</style>
<style scoped lang="less" type="text/less">
	.app-container {
  .treeContainer {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border: 1px solid  rgba(220,223,230,0.6);

    .treeTitle {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #409eff;
      padding-left: 6px;
    }
  }
}
</style>
